export default "__VITE_ASSET__ef5a0814__"